/**
 * 지원하는 트래킹 이벤트 유형
 * @enum {string}
 */
export const TrackerEvent = {
  PAGE_VIEW: 'PAGE_VIEW',
  USER_SIGNUP: 'USER_SIGNUP', // 가입 (회원 가입 완료)
  USER_LOGIN: 'USER_LOGIN', // 로그인 (로그인 페이지 진입)
  COURSE_VIEW: 'COURSE_VIEW', // 코스 상페 내용 확인
  CATEGORY_VIEW: 'CATEGORY_VIEW', // Bridge 페이지 내용 확인
  FORMAT_VIEW: 'FORMAT_VIEW',
  ENROLLMENT_VIEW: 'ENROLLMENT_VIEW', // 수강신청 페이지 내용 확인
  ENROLLMENT_PENDING: 'ENROLLMENT_PENDING', // 수강신청 완료 => 수강정보 생성 => 대기상태 설정
  TRANSACTION_ORDER: 'TRANSACTION_ORDER', // 결제 페이지 내용 확인
  TRANSACTION_PAYMENT: 'TRANSACTION_PAYMENT', // 결제 완료
  COMMON: 'COMMON', // 조회 -> 결제 프로세스 이외의 것
};
